import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// import { set } from 'tripetto-runner-foundation';
import logo from '../../assets/logo/radis.png'

const NavbarTop = () => {
    const [menu, setMenu] = useState(false);
    return (
        <>
            <div className='fixed bg-[#F3F5F7] w-full h-20 flex shadow-xl font-Poppins-Regular font-bold justify-between z-50'>
                <div className='ml-10 flex items-center'>
                    <div className='h-10 w-10 items-center flex'>
                        <img className=' ml-[-10px]' src={logo} alt='logo' />
                    </div>
                    <div className='text-3xl font-PoetsenOne'>
                        Lokalité
                    </div>
                </div>
                <div className='hidden xl:w-full xl:flex xl:justify-center'>
                    <div className='top-5 h-20 flex items-center text-black text-lg'>
                        <Link to='/'>
                            <button className='h-12 w-[135px] text-sm'>
                                Accueil
                            </button>
                        </Link>
                        <button className='h-12 w-[135px] text-sm'>
                            Pourquoi?
                        </button>
                        <button className='h-12 w-[135px] text-sm'>
                            Blog
                        </button>
                        <button className='h-12 w-[135px] text-sm'>
                            À propos
                        </button>
                    </div>
                </div>
                <div className='flex'>
                    <div className='hidden mr-8 lg:flex items-center'>
                        <Link to='/SignIn'>
                            <button className='text-[#169A6A] h-12 w-36 text-sm'>
                                Connexion
                            </button>
                        </Link>
                        <a href='https://tripetto.app/run/RHFT8IWYRY' target='_blank'>
                            <button className='bg-[#169A6A] rounded-lg text-white h-12 w-48 text-sm'>
                                Demander une démo
                            </button>
                        </a>
                    </div>
                    <div className='xl:hidden w-[70px] h-full flex items-center text-white'>
                        <button className='bg-[#169A6A] w-12 h-12 rounded-lg justify-center flex items-center' onClick={() => { setMenu(!menu) }}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                            </svg>

                        </button>
                    </div>
                </div>
            </div>
            {menu ? (
                <div className='bg-[#F3F5F7] relative top-[129px] w-full shadow-xl font-Poppins-Regular font-bold'>
                    <div className='relative text-black text-lg xl:hidden left-[20px]'>
                        <Link to='/'>
                            <p className='h-12 w-[135px]'>
                                Acceuil
                            </p>
                        </Link>
                        <p className='h-12 w-[135px]'>
                            Pourquoi?
                        </p>
                        <p className='h-12 w-[135px]'>
                            Blog
                        </p>
                        <p className='h-12 w-[135px]'>
                            À propos
                        </p>
                        <div className='lg:hidden absolute top-[20px] h-20 right-[50px]'>
                            <Link to='/SignIn'>
                                <button className='text-[#169A6A] h-12 w-36 text-sm'>
                                    Connexion
                                </button>
                            </Link>
                        </div>
                        <div className='lg:hidden absolute top-[120px] h-20 right-[50px]'>
                            <a href='https://tripetto.app/run/RHFT8IWYRY' target='_blank'>
                                <button className='bg-[#169A6A] rounded-lg text-white h-12 w-48 text-sm'>
                                    Demander une démo
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            )
                :
                (
                    null
                )}
        </>
    )
}


export default NavbarTop